import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonReviseProduct(props) {
    const map = useMapContext()
    const canReviseProduct = map.useCanReviseProduct()

    if (! canReviseProduct) {
        return null
    }

    const onClick = () => map.cmdReviseProduct()

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            修订制品
        </MenuButton>
    )
}
